import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ActionComponent} from '../../action/action.component';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {FormChangesGuard} from '../../../resources/guards/formChanges.guard';
import {routerHandler} from '../../../resources/utils/router';
import {ActionIndexComponent} from '../../action/action-index/action-index.component';
import {ActionCreateComponent} from '../../action/action-create/action-create.component';
import {ActionEditComponent} from '../../action/action-edit/action-edit.component';
import {CustomDataCreateComponent} from '../custom-data-create/custom-data-create.component';
import {CustomDataEditComponent} from '../custom-data-edit/custom-data-edit.component';


export const CustomDataRoutes: Routes = [
  {
    path: 'custom-data',
    data: {
      title: 'Custom data',
      hidden: true,
    },
    component: ActionComponent,
    canActivate: [AuthUsersGuard],
    canDeactivate: [FormChangesGuard],
    children: [
      routerHandler.create('custom-data', {component: CustomDataCreateComponent}),
      routerHandler.edit('custom-data', {component: CustomDataEditComponent}),
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(CustomDataRoutes)],
  exports: [RouterModule]
})
export class CustomDataRoutesModule { }
